module.exports = __webpack_public_path__ + "static/media/chili-pepper.9e492e5f.svg";